<template>
  <div class="user-avatar-dropdown"
      @mouseenter="handleMouseenter"
      @mouseleave="handleMouseleave">
      <Avatar :src="userAvatar" :alt="userName" :title="userName" size="large"/>
      <div class="dropdown"  v-show="currentVisible">
            <div class="dropdown-header">
                <Avatar :src="userAvatar" :alt="userName" :title="userName" size="large"/>
                <h4>
                    <p>{{userName}} ({{realname}})</p>
                    <small v-if="isadmin" class="mb-0 opacity-80">超级管理员</small>
                    <small v-else class="mb-0 opacity-80">{{posts}}</small>
                </h4>
            </div>
            <div>
                <ul class="dropdown-item">
                  <li v-show="isadmin" @click="Enterprise"><Icon type="logo-instagram" /> 企业配置</li>
                  <li @click="Message"><Icon type="ios-radio" /> 消息中心</li>
                  <li @click="repassword"><Icon type="md-lock" /> 重置密码</li> 
                  <li @click="logout"><Icon type="md-log-out" /> 退出登录 <span>{{email}}</span></li>
                </ul>
            </div>
        </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'users',
    data () {
        return {
            currentVisible: false
        };
    },
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: 'admin'
    },
    realname: {
      type: String,
      default: '超级管理员'
    },
    email: {
      type: String,
      default: 'fgf67@163.com'
    },
    posts: {
      type: String,
      default: '总经理'
    },
    isadmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    ...mapMutations([
      'setCollapsed'
    ]),
    logout () {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    Enterprise() {
      this.setCollapsed(true)
      this.$router.push({
        name: 'enterprise'
      })
    },
    Message () {
      this.setCollapsed(true)
      this.$router.push({
        name: 'message'
      })
    },
    repassword () {
        this.setCollapsed(true)
      this.$router.push({
        name: 'repassword'
      })
    },
    

    
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message':
          break
        case 'editPassData': 
          break
      }
    },
    handleMouseenter () {
      this.currentVisible = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
          this.currentVisible = true;
      }, 250);
    },
    handleMouseleave () {
      this.currentVisible = false;
      if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
          this.currentVisible = false;
      }, 150);
      }
    },
  }
}

</script>

<style lang="less" scoped>
.user{
  &-avatar-dropdown{
    width: 54px;
    text-align: center;
    background: #f1f1f1;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    &:hover {
       background: linear-gradient(250deg,#3a455b,#3f4d67);
    }

  .dropdown {
        width: 240px;
        height: auto;
        display: block;
        -webkit-transform: scale(1)!important;
        transform: scale(1)!important;
        -webkit-transform-origin: 29px -50px;
        transform-origin: 29px -50px;
        opacity: 1;
        visibility: visible;
        position: absolute;
        will-change: top, left;
        border: 0 solid #ccc;
        right: 9px;
        top: 3.3rem!important;
        left: auto!important;
        padding: 0;
        margin: 0;
        -webkit-box-shadow: 4px 10px 15px 1px rgba(90, 80, 105, 0.2);
        box-shadow: 4px 10px 15px 0px rgba(90, 80, 105, 0.2);
        -webkit-user-select: text;
        transform: perspective(500px) rotateX(60deg);
        z-index: 99999;
        &-header {
            display: -webkit-box!important;
            display: -ms-flexbox!important;
            display: flex!important;
            -webkit-box-orient: horizontal!important;
            -webkit-box-direction: normal!important;
            -ms-flex-direction: row!important;
            flex-direction: row!important;
            -webkit-box-align: center!important;
            -ms-flex-align: center!important;
            align-items: center!important;
            background: linear-gradient(250deg, #3a455b, #3f4d67);

            .ivu-avatar {
                margin-left: 20px;
            }
            h4 {
                font-weight: 400;
                line-height: 22px;
                font-size: 14px;
                color: #ffffffd1;
                  text-align: left;
                padding: 10px;
                small {
                    font-weight: 300;
                    color:#ffffff99;
                    display: block;
                     line-height: 22px;
                    text-align: left;
                    font-size: 12px;
                }
            }
        }
        &-item {
            background: #fff;
            list-style:none;
            line-height: 32px;
            text-align: left;
            li {
                padding: 10px 18px;
                border-bottom: 1px solid #f1f1f1;
                &:hover {
                    background: #f1f1f1;
                }
                h3 {
                    font-size: 14px;
                }
                p {
                    font-size: 12px;
                }
                span {
                    float:right;
                    font-size: 12px;
                    color:#999;
                }
            }
        }
        &-more {
            line-height: 42px;
            background: #f7f9fa;
            color: #666;
            text-align: right;
            span {
                color: #58b1eb;
                padding: 0px 15px;
                &:hover {

                }
            }
        }
    }
  }
}
</style>
